import React from "react";
import "./Marketing.css";

const MarketingDashboard = () => {
  return (
    <div className="marketing-page">
      <div className="marketing-header">
        <div>
          <div className="marketing-eyebrow">
            BUSINESS DEVELOPMENT / MARKETING
          </div>

          <h1>AI Marketing Dashboard</h1>

          <p>
            Create, manage, review and approve AI-assisted marketing content.
          </p>
        </div>

        <button className="marketing-create-btn">✨ Create AI Post</button>
      </div>

      <div className="marketing-stats">
        <div className="marketing-stat-card draft-card">
          <div className="stat-icon">📝</div>
          <div>
            <strong>12</strong>
            <span>Draft Posts</span>
          </div>
        </div>

        <div className="marketing-stat-card review-card">
          <div className="stat-icon">👀</div>
          <div>
            <strong>4</strong>
            <span>Review Required</span>
          </div>
        </div>

        <div className="marketing-stat-card approved-card">
          <div className="stat-icon">✓</div>
          <div>
            <strong>3</strong>
            <span>Approved</span>
          </div>
        </div>

        <div className="marketing-stat-card published-card">
          <div className="stat-icon">🚀</div>
          <div>
            <strong>28</strong>
            <span>Published</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketingDashboard;
